<template>
    <div id="generals" class="generals ping">
        <!-- 标题 -->
        <div class="generals-row">
            <div class="generals-header">
                <span v-if="isMobile" style="color:F8F2D8;">{{$t("role")}}</span>
            </div>
        </div>
        <!-- 武将图 -->
        <div class="generals-row">
            <div v-if="lang=='zh-CN'" class="swiper-box">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang1-cn.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang2-cn.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang3-cn.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang4-cn.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang5-cn.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang6-cn.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang7-cn.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang8-cn.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang9-cn.png?v=1'" alt />
                        </div>
                    </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination page"></div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
            <div v-if="lang=='ja'" class="swiper-box">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang1-ja.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang2-ja.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang3-ja.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang4-ja.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang5-ja.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang6-ja.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang7-ja.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang8-ja.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang9-ja.png?v=1'" alt />
                        </div>
                    </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination page"></div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
            <div v-if="lang=='en'" class="swiper-box">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang1-en.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang2-en.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang3-en.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang4-en.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang5-en.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang6-en.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang7-en.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang8-en.png?v=1'" alt />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang9-en.png?v=1'" alt />
                        </div>
                    </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination page"></div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
            <div v-if="lang=='th'" class="swiper-box">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang1-th.png?v=1'" />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang2-th.png?v=1'" />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang3-th.png?v=1'" />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang4-th.png?v=1'" />
                        </div>
                        <div class="swiper-slide">
                            <img :src="imgUrl+'/wujiang5-th.png?v=1'" />
                        </div>
                    </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination page"></div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";

export default {
    name: "Generals",
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            imgUrl: this.cdnPrefix + "/imgs",
            lang: window.localStorage.getItem("localeLanguage")
        };
    },
    components: {},
    mounted() {
        this._initSwiper();
    },
    methods: {
        // Swiper
        _initSwiper() {
            let mySwiper = new Swiper("#generals .swiper-container", {
                initalSlide: 2, //设定初始化时slide的索引，
                // direction: "vertical",//slide的滑动方向
                speed: 500, //滑动速度，开始滑动到结束滑动的时间
                autoplay: 500, //可选选项，自动滑动,值为自动滑动的间隔
                autoplayDisableOnInteraction: false, //操作后是否停止自动滑动
                autoplayStopOnLast: false, //设置为true，切换到最后一个slide时停止自动切换
                grabCursor: true, //拖动时指针会变成抓手形状
                loop: true,
                // 分页器 - 即小圆点
                pagination: {
                    el: "#generals .swiper-pagination",
                    clickable: true, //可点击切换
                    type: "bullets" //bullets 圆点（默认） fraction 分式 progressbar 进度条 custom 自定义
                },
                // 左右的切换按钮
                navigation: {
                    nextEl: "#generals .swiper-button-next",
                    prevEl: "#generals .swiper-button-prev"
                },
                // 鼠标滚轮控制切换
                mousewheel: true,
                // 切换效果 fade cube coverflow flip
                effect: "coverflow",
                centeredSlides: true,
                slidesPerView: "auto",
                coverflowEffect: {
                    rotate: 50,
                    stretch: 10,
                    depth: 100,
                    modifier: 1,
                    slideShadows: false
                }
            });
        }
    }
};
</script>

<style lang="scss">
.generals {
    height: 100%;
    padding: 70px 0 0;
    .generals-row {
        width: 100%;
        display: flex;
        justify-content: center;
        .generals-header {
            width: 350px;
            height: 100px;
            margin-top: 50px;
            img {
                width: 100%;
            }
        }
        .swiper-box {
            position: relative;
            width: 1200px;
            margin: 0 auto;
            padding: 0 100px;
            .swiper-container {
                width: 100%;
                .swiper-wrapper {
                    .swiper-slide {
                        width: 1000px;
                        img {
                            width: 1000px;
                        }
                    }
                }
            }
            // 分页按钮
            .swiper-pagination {
                width: 1000px;
                height: 50px;
                line-height: 50px;
                .swiper-pagination-bullet {
                    width: 12px;
                    height: 12px;
                    margin: 0 5px;
                    background: #fff;
                    opacity: 0.8;
                    transition: all 0.1s linear;
                    outline: none;
                }
                .swiper-pagination-bullet-active {
                    background: #f00;
                }
            }
            // 翻页按钮
            .swiper-button-prev,
            .swiper-button-next {
                width: 40px;
                height: 40px;
                padding: 5px;
                border-radius: 50%;
                outline: none;
            }
            .swiper-button-prev {
                background: url($cdnPrefix+"/imgs/btn_prev.png") center center
                    no-repeat;
                background-size: 20px 30px;
                background-color: rgba(204, 204, 204, 0.3);
                left: 5px;
            }
            .swiper-button-next {
                background: url($cdnPrefix+"/imgs/btn_next.png") center center
                    no-repeat;
                background-size: 20px 30px;
                background-color: rgba(204, 204, 204, 0.3);
                right: 5px;
            }
        }
    }
}
// 多语言
.lang-zh-CN {
    .generals {
        .generals-row {
            .generals-header {
                background: url($cdnPrefix+"/imgs/wujiang-text-cn.png") center
                    center no-repeat;
                background-size: 100% auto;
            }
        }
    }
}
.lang-ja {
    .generals {
        .generals-row {
            .generals-header {
                background: url($cdnPrefix+"/imgs/wujiang-text-ja.png") center
                    center no-repeat;
                background-size: 100% auto;
            }
        }
    }
}
.lang-en {
    .generals {
        .generals-row {
            .generals-header {
                background: url($cdnPrefix+"/imgs/wujiang-text-en.png") center
                    center no-repeat;
                background-size: 100% auto;
            }
        }
    }
}
.lang-th {
    .generals {
        .generals-row {
            .generals-header {
                background: url($cdnPrefix+"/imgs/wujiang-text-th.png") center
                    center no-repeat;
                background-size: 100% auto;
            }
        }
    }
}
// 适配小屏
@media screen and (max-width: 1366px) {
    .generals {
        .generals-row {
            .swiper-box {
                position: relative;
                width: 800px;
                margin: 0 auto;
                padding: 0 50px;
                .swiper-container {
                    .swiper-wrapper {
                        width: 100%;
                        .swiper-slide {
                            width: 100%;
                            img {
                                width: 700px;
                            }
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 700px;
                    height: 30px;
                    line-height: 30px;
                }
            }
        }
    }
}
@media screen and (max-width: 768px) {
    .generals {
        height: auto;
        padding: 50px 0;
        background: url($cdnPrefix+"/imgs/bgphone-p20n.png") center center
            no-repeat;
        background-size: 100% auto;
        .generals-row {
            .generals-header {
                width: 250px;
                height: 60px;
                margin: 20px auto 0;
            }
            .swiper-box {
                width: 600px;
                .swiper-container {
                    .swiper-wrapper {
                        .swiper-slide {
                            img {
                                width: 500px;
                            }
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 500px;
                }
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    top: 330px;
                }
            }
        }
    }
}
@media screen and (max-width: 414px) {
    #generals {
        padding: 0;
        .generals-row {
            .generals-header {
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-weight: bold;
                color: #f8f2d8;
                background: url($cdnPrefix+"/imgs/bgphone-title.png") center
                    center no-repeat;
                background-size: 330px 35px;
                text-align: center;
                margin: 0 auto;
            }
            .swiper-box {
                width: 100%;
                height: 300px;
                padding: 0;
                margin-top: -10px;
                .swiper-container {
                    width: 100%;
                    margin-bottom: 7px;
                    .swiper-wrapper {
                        width: 100%;
                        .swiper-slide {
                            width: 95%;
                            text-align: center;
                            img {
                                width: 100%;
                            }
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 100%;
                }
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    top: 270px;
                }
                .swiper-button-prev {
                    left: 40px;
                }
                .swiper-button-next {
                    right: 40px;
                }
            }
        }
    }
}
@media screen and (max-width: 375px) {
    #generals {
        .generals-row {
            .swiper-box {
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    top: 250px;
                }
            }
        }
    }
}
@media screen and (max-width: 360px) {
    #generals {
        .generals-row {
            .swiper-box {
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    top: 240px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Generals.vue